import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebase/firebaseConfig'
import store from '@/store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login')
  },
  {
    // Recaudación es ahora el dashboard principal
    path: '/',
    name: 'collection-dashboard',
    component: () => import('../views/collection/Dashboard'),
    meta: {
      auth: true
    }
  },
  {
    // Compat: rutas antiguas /collection redirigen a la raíz
    path: '/collection',
    redirect: '/'
  },
  {
    path: '/collection/pending',
    name: 'pending-bills',
    component: () => import('../views/collection/PendingBills'),
    meta: {
      auth: true
    }
  },
  {
    path: '/tenants',
    name: 'tenants',
    component: () => import(/* webpackChunkName: "about" */ '../views/tenants/App'),
    meta: {
      auth: true
    }
  },
  {
    path: '/tenants/bills/:id',
    redirect: to => ({ name: 'tenant-detail', params: { id: to.params.id }, query: { tab: 'bills' } })
  },
  {
    path: '/tenants/taxes/:id',
    redirect: to => ({ name: 'tenant-detail', params: { id: to.params.id }, query: { tab: 'taxes' } })
  },
  {
    path: '/tenants/contracts/:id',
    redirect: to => ({ name: 'tenant-detail', params: { id: to.params.id }, query: { tab: 'contracts' } })
  },
  {
    path: '/tenants/:id',
    name: 'tenant-detail',
    component: () => import('../views/tenants/TenantDetail'),
    meta: { auth: true }
  },
  {
    path: '/estates',
    name: 'estates',
    component: () => import(/* webpackChunkName: "about" */ '../views/estates/App'),
    meta: {
      auth: true
    }
  },
  {
    path: '/estates/taxes/:id',
    name: 'estates-taxes',
    component: () => import(/* webpackChunkName: "about" */ '../views/estates/taxes/App'),
    meta: {
      auth: true
    }
  },
  {
    path: '/estates/:id',
    name: 'estate-detail',
    component: () => import('../views/estates/EstateDetail'),
    meta: {
      auth: true
    }
  },
  {
    path: '/expenses',
    name: 'expenses',
    component: () => import(/* webpackChunkName: "about" */ '../views/expenses/App'),
    meta: {
      auth: true
    }
  },
  {
    path: '/sales',
    name: 'sales',
    component: () => import(/* webpackChunkName: "about" */ '../views/sales/App'),
    meta: {
      auth: true
    }
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('../views/Onboarding'),
    meta: {
      auth: true
    }
  },
  {
    path: '/admins',
    name: 'admins',
    component: () => import('../views/admins/App'),
    meta: { auth: true, admin: true }
  },
  {
    path: '/payroll',
    name: 'payroll',
    component: () => import('../views/payroll/App'),
    // Sueldos del personal: solo admin. Sin esto cualquier cuenta autenticada
    // (inquilino o expositor de la app) llega a /payroll por URL y se topa con
    // una pantalla vacía y errores de permisos de Firestore.
    meta: { auth: true, admin: true }
  },
  {
    path: '/changelog',
    name: 'changelog',
    component: () => import('../views/Changelog'),
    meta: {
      public: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  auth.onAuthStateChanged(async () => {
    // get firebase current user
    const firebaseCurrentUser = auth.currentUser
    // If auth required, check login. If login fails redirect to login page
    if (to.meta.auth) {
      if (!(firebaseCurrentUser)) {
        store.dispatch('showLogin')
        return next('/login')
      } else {
        store.dispatch('hideLogin')
        // If route requires admin claim, verify it before allowing access
        if (to.meta.admin) {
          const idTokenResult = await firebaseCurrentUser.getIdTokenResult()
          if (idTokenResult.claims.admin !== true) {
            return next('/')
          }
        }
        return next()
      }
    } else {
      return next()
    }
  })
})

export default router
